import {MessageNode} from "../messageObject/MessageNode.ts";
import messageIdMapping from "../IdMappings/MessageIdMapping.ts";
import {formatDate} from "./dateUtils.ts";

export const getLastReferences = (currentNode: MessageNode) => {
    while (currentNode) {
        if (currentNode.message && currentNode.message.role === "user") {
            if (currentNode.metadata.references) return currentNode.metadata.references;
            else return [];
        }

        if (currentNode.parent === null) break;
        currentNode = messageIdMapping[currentNode.parent];
    }

    return [];
}

export const getLastUserMessage = (currentMessageRef: any) => {
    let messageIterator = currentMessageRef.current;
    while (messageIterator) {
        if (messageIterator.message.role === "user") {
            return messageIterator;
        }
        messageIterator = messageIdMapping[messageIterator.parent];
    }
}

export function getReferenceDifferences(arrayA: any[], arrayB: any[]) {
    const differenceAtoB = arrayA.filter(valueA =>
        !arrayB.some(valueB => valueA.path === valueB.path && valueA.type === valueB.type)
    );
    const differenceBtoA = arrayB.filter(valueB =>
        !arrayA.some(valueA => valueB.path === valueA.path && valueB.type === valueA.type)
    );

    return [
        differenceAtoB,
        differenceBtoA
    ];
}

export const setupMetadata = (currentMessageRef: any) => {
    let isDifferentDate;

    const lastUserMessage = getLastUserMessage(currentMessageRef);
    const lastUserParent = messageIdMapping[lastUserMessage.parent];

    const currentMessageRefDate = formatDate(lastUserMessage.metadata.timestamp);
    if (lastUserParent?.metadata?.timestamp) {
        const parentRefDate = formatDate(lastUserParent.metadata.timestamp);
        isDifferentDate = currentMessageRefDate !== parentRefDate;
    } else {
        isDifferentDate = true;
    }
    if (isDifferentDate) lastUserMessage.metadata.dateToRender = currentMessageRefDate;
}
